import React, { useEffect, useState } from "react";
import {
  transformResultsToTableData,
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function MarketShareAnalysis({ marketShareAnalysis, compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "market_segment", label: "Market Segment" },
        { key: "company_position", label: "Company Position" },
      ];
      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "market_segment", label: "Market Segment" },
        { key: "market_leader", label: "Market Leader" },
        { key: "strong_players", label: "Strong Players" },
        // { key: "emerging_players", label: "Emerging Players" },
        { key: "company_position", label: "Company Position" },
      ];
      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     market_segment: {
  //       value: "Commercial Flooring ($2.1B)",
  //     },
  //     market_leader: {
  //       value: "Taylor",
  //     },
  //     strong_players: {
  //       value: "H.B. Fuller, Sika",
  //     },
  //     emerging_players: {
  //       value: "Regional players",
  //     },
  //     taylor_position: {
  //       value: "Market Leader",
  //     },
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(marketShareAnalysis);
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   marketShareAnalysis?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={marketShareAnalysis?.[0]?.response?.["tableComments"] || ""}
      />
    );
    // setTabData(dummyData);
  }, [marketShareAnalysis]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Market Share Analysis"
      subtitle=""
      // belowTableDescription={`The real story behind the numbers: Taylor has mastered the art of strategic positioning - they dominate 73% of the premium segments ($2.75B [2][5] combined commercial + green markets) while cleverly avoiding direct confrontation in H.B. Fuller's stronghold of residential flooring ($1.8B [2] market). But here's the kicker: Taylor's green adhesives segment is growing 34% [5] annually compared to just 8% [5] for traditional commercial flooring, suggesting they're riding the sustainability wave perfectly while competitors scramble to catch up.`}
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={columns}
      rowIdentifier="market_segment"
      actions={actions}
    />
  );
}

export default MarketShareAnalysis;
